import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import getHelpCenterUrl from '@alltrails/shared/utils/constants/helpCenterUrl';
import Link from '@alltrails/denali/components/Link';
import Toast from '@alltrails/denali/components/Toast';
import { useSelector } from '../../redux';

const TerrainInstructionsToast = () => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false);

  const { is3dActive } = useSelector(state => ({
    is3dActive: state.map.is3dActive
  }));

  const href = getHelpCenterUrl(languageRegionCode, 37213898696340);

  const shouldShowToast = useMemo(() => {
    return Boolean(is3dActive && !hasBeenDismissed);
  }, [hasBeenDismissed, is3dActive]);

  useEffect(() => {
    setIsToastOpen(shouldShowToast);
  }, [shouldShowToast]);

  return (
    <Toast
      action={() => setHasBeenDismissed(true)}
      actionText={intl.formatMessage({ defaultMessage: 'Close' })}
      isOpen={isToastOpen}
      message={
        <>
          <FormattedMessage defaultMessage={`Tilt and rotate by holding "control" and dragging up, down, left, or right.`} />{' '}
          <Link href={href} target="_blank" testId="terrain-instructions-learn-more" variant="inverse">
            <FormattedMessage defaultMessage="Learn more" />
          </Link>
        </>
      }
      position="primary"
      setIsOpen={setIsToastOpen}
      testId="terain-instructions-toast"
      timeout={7000}
      type="success"
    />
  );
};

export default TerrainInstructionsToast;
